import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_3 = {
    key: 0,
    class: "row"
};
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-md-6 mb-20" };
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center mb-10" };
const _hoisted_7 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_8 = { class: "col-md-6 mb-20" };
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center mb-10" };
const _hoisted_10 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_11 = { class: "row mt-20" };
const _hoisted_12 = { class: "col-md-6" };
const _hoisted_13 = { class: "form-group mb-15" };
const _hoisted_14 = { class: "d-flex align-items-center" };
const _hoisted_15 = { class: "col-md-6" };
const _hoisted_16 = { class: "form-group mb-15" };
const _hoisted_17 = { class: "d-flex align-items-center" };
const _hoisted_18 = { class: "col-md-3" };
const _hoisted_19 = { class: "form-group mb-15" };
const _hoisted_20 = { class: "d-flex align-items-center" };
const _hoisted_21 = { class: "col-md-3" };
const _hoisted_22 = { class: "form-group mb-15" };
const _hoisted_23 = { class: "d-flex align-items-center" };
const _hoisted_24 = { class: "col-md-3" };
const _hoisted_25 = { class: "form-group mb-15" };
const _hoisted_26 = { class: "d-flex align-items-center" };
const _hoisted_27 = { class: "col-md-3" };
const _hoisted_28 = { class: "form-group mb-15" };
const _hoisted_29 = { class: "d-flex align-items-center" };
const _hoisted_30 = { class: "col-md-6" };
const _hoisted_31 = { class: "form-group mb-15" };
const _hoisted_32 = { class: "col-md-3" };
const _hoisted_33 = { class: "form-group mb-15" };
const _hoisted_34 = { class: "d-flex align-items-center" };
const _hoisted_35 = { class: "col-md-3" };
const _hoisted_36 = { class: "form-group mb-15" };
const _hoisted_37 = { class: "d-flex align-items-center" };
const _hoisted_38 = { class: "col-md-6" };
const _hoisted_39 = { class: "form-group mb-15" };
const _hoisted_40 = { class: "input-group" };
const _hoisted_41 = { class: "d-flex justify-content-end mt-25 align-items-center" };
const _hoisted_42 = ["disabled"];
const _hoisted_43 = ["disabled"];
const _hoisted_44 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_45 = {
    key: 1,
    class: "ph ph-check-circle me-2 fs-18"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_BreadCrumb, { PageTitle: "Design & Templates Web" }),
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _cache[45] || (_cache[45] = _createElementVNode("div", { class: "d-flex align-items-center justify-content-between mb-15" }, [
                    _createElementVNode("h5", { class: "card-title fw-bold mb-0 text-primary" }, " 🎨 Personnalisation du Thème ")
                ], -1)),
                _cache[46] || (_cache[46] = _createElementVNode("p", { class: "text-muted small mb-20" }, " Personnalisez l'apparence de votre site e-commerce public. Configurez votre charte graphique et votre nom de domaine SaaS. ", -1)),
                (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[22] || (_cache[22] = [
                            _createElementVNode("div", { class: "col-12 text-center py-5" }, [
                                _createElementVNode("div", {
                                    class: "spinner-border text-primary",
                                    role: "status"
                                })
                            ], -1)
                        ]))]))
                    : (_openBlock(), _createElementBlock("form", {
                        key: 1,
                        onSubmit: _cache[21] || (_cache[21] = _withModifiers(() => _ctx.saveThemeSettings('publish'), ["prevent"]))
                    }, [
                        _cache[43] || (_cache[43] = _createElementVNode("h6", { class: "text-black fw-bold mb-20 text-uppercase letter-spacing mt-30" }, "Bibliothèque de thèmes", -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["border rounded-0 p-15 cursor-pointer transition-all", _ctx.formData.web_template_id === 'FOOD_MARKET' ? 'border-primary-active' : 'border-light']),
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.formData.web_template_id = 'FOOD_MARKET'))
                                }, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "fw-bold fs-14" }, "Food Market", -1)),
                                        (_ctx.formData.web_template_id === 'FOOD_MARKET')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "ACTIF"))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "theme-thumbnail food-market-preview" }, null, -1))
                                ], 2)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["border rounded-0 p-15 cursor-pointer transition-all", _ctx.formData.web_template_id === 'EATS_MODERN' ? 'border-primary-active' : 'border-light']),
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.formData.web_template_id = 'EATS_MODERN'))
                                }, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "fw-bold fs-14" }, "Eats Modern", -1)),
                                        (_ctx.formData.web_template_id === 'EATS_MODERN')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "ACTIF"))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "theme-thumbnail eats-modern-preview" }, null, -1))
                                ], 2)
                            ])
                        ]),
                        _cache[44] || (_cache[44] = _createElementVNode("hr", { class: "my-30" }, null, -1)),
                        _createElementVNode("div", _hoisted_11, [
                            _cache[40] || (_cache[40] = _createElementVNode("div", { class: "col-md-12" }, [
                                _createElementVNode("h6", { class: "text-black fw-bold mb-20 text-uppercase letter-spacing" }, "Charte Graphique & Domaine")
                            ], -1)),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Couleur Primaire (Boutons, En-têtes)", -1)),
                                    _createElementVNode("div", _hoisted_14, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "color",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.themeConfig.primary) = $event)),
                                            class: "form-control form-control-color shadow-none rounded-0 border-0 p-0 me-2",
                                            style: { "width": "40px", "height": "38px", "cursor": "pointer" }
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.primary]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black fw-bold text-uppercase",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.themeConfig.primary) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.primary]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Couleur Secondaire (Accents, Icônes)", -1)),
                                    _createElementVNode("div", _hoisted_17, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "color",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.themeConfig.secondary) = $event)),
                                            class: "form-control form-control-color shadow-none rounded-0 border-0 p-0 me-2",
                                            style: { "width": "40px", "height": "38px", "cursor": "pointer" }
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.secondary]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black fw-bold text-uppercase",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.themeConfig.secondary) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.secondary]
                                        ])
                                    ])
                                ])
                            ]),
                            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-md-12 mt-10" }, [
                                _createElementVNode("h6", { class: "text-black fw-bold mb-15 text-uppercase fs-13" }, "Fonds de page & Structures")
                            ], -1)),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Fond Header", -1)),
                                    _createElementVNode("div", _hoisted_20, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "color",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.themeConfig.headerBg) = $event)),
                                            class: "form-control form-control-color shadow-none rounded-0 border-0 p-0 me-2",
                                            style: { "width": "40px", "height": "38px", "cursor": "pointer" }
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.headerBg]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black fw-bold text-uppercase",
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.themeConfig.headerBg) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.headerBg]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                    _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Fond Footer", -1)),
                                    _createElementVNode("div", _hoisted_23, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "color",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.themeConfig.footerBg) = $event)),
                                            class: "form-control form-control-color shadow-none rounded-0 border-0 p-0 me-2",
                                            style: { "width": "40px", "height": "38px", "cursor": "pointer" }
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.footerBg]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black fw-bold text-uppercase",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.themeConfig.footerBg) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.footerBg]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                    _cache[31] || (_cache[31] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Fond Page", -1)),
                                    _createElementVNode("div", _hoisted_26, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "color",
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.themeConfig.bodyBg) = $event)),
                                            class: "form-control form-control-color shadow-none rounded-0 border-0 p-0 me-2",
                                            style: { "width": "40px", "height": "38px", "cursor": "pointer" }
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.bodyBg]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black fw-bold text-uppercase",
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.themeConfig.bodyBg) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.bodyBg]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Fond Sections (Surface)", -1)),
                                    _createElementVNode("div", _hoisted_29, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "color",
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.themeConfig.surfaceBg) = $event)),
                                            class: "form-control form-control-color shadow-none rounded-0 border-0 p-0 me-2",
                                            style: { "width": "40px", "height": "38px", "cursor": "pointer" }
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.surfaceBg]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black fw-bold text-uppercase",
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.themeConfig.surfaceBg) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.surfaceBg]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                    _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Style des éléments visuels", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.themeConfig.borderRadius) = $event)),
                                        class: "form-select shadow-none fw-semibold rounded-0"
                                    }, [...(_cache[33] || (_cache[33] = [
                                            _createElementVNode("option", { value: "0px (Carré)" }, "0px (Carré)", -1),
                                            _createElementVNode("option", { value: "8px (Arrondi léger)" }, "8px (Arrondi léger)", -1),
                                            _createElementVNode("option", { value: "24px (Ovale)" }, "24px (Ovale)", -1)
                                        ]))], 512), [
                                        [_vModelSelect, _ctx.themeConfig.borderRadius]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                    _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Badge Panier", -1)),
                                    _createElementVNode("div", _hoisted_34, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "color",
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.themeConfig.cartBadgeBg) = $event)),
                                            class: "form-control form-control-color shadow-none rounded-0 border-0 p-0 me-2",
                                            style: { "width": "40px", "height": "38px", "cursor": "pointer" }
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.cartBadgeBg]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black fw-bold text-uppercase",
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.themeConfig.cartBadgeBg) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.cartBadgeBg]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                    _cache[36] || (_cache[36] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Tags Produits", -1)),
                                    _createElementVNode("div", _hoisted_37, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "color",
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.themeConfig.cartTagBg) = $event)),
                                            class: "form-control form-control-color shadow-none rounded-0 border-0 p-0 me-2",
                                            style: { "width": "40px", "height": "38px", "cursor": "pointer" }
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.cartTagBg]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black fw-bold text-uppercase",
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.themeConfig.cartTagBg) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.themeConfig.cartTagBg]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Votre Domaine SaaS", -1)),
                                    _createElementVNode("div", _hoisted_40, [
                                        _cache[37] || (_cache[37] = _createElementVNode("span", { class: "input-group-text rounded-0 bg-light border-end-0 text-muted" }, "https://", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black border-start-0 ps-0",
                                            placeholder: "votre-restaurant.com",
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.formData.custom_domain) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.formData.custom_domain]
                                        ])
                                    ]),
                                    _cache[39] || (_cache[39] = _createElementVNode("small", { class: "text-muted mt-1 d-block" }, "Entrez seulement le domaine (sans https ni / à la fin).", -1))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-outline-secondary px-4 py-2 fw-bold rounded-2 shadow-sm me-3",
                                onClick: _cache[20] || (_cache[20] = ($event) => (_ctx.saveThemeSettings('draft'))),
                                disabled: _ctx.loading
                            }, " Mettre en brouillon (Tester) ", 8, _hoisted_42),
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn-success text-white px-5 py-2 fw-bold rounded-2 shadow-sm",
                                disabled: _ctx.loading
                            }, [
                                (_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_45)),
                                _cache[42] || (_cache[42] = _createTextVNode(" Enregistrer le Thème ", -1))
                            ], 8, _hoisted_43)
                        ])
                    ], 32))
            ])
        ])
    ], 64));
}
